const halfHourTemplates = (prefix) => {
  let template = ``
  // Polska
  if(prefix === "+48") {
    template = `Twoje zamówienie zostanie dostarczone w ciągu 30 minut.`
  }
  // Niemcy
  if(prefix === "+49") {
    template = `Ihre Bestellung wird innerhalb von 30 Minuten zugestellt.`
  }
  // Francja
  if(prefix === "+33") {
    template = `Votre commande sera livrée dans les 30 minutes`
  }
  // Luksemburg
  if(prefix === "+352") {
    template = `Ihre Bestellung wird innerhalb von 30 Minuten zugestellt`
  }
  // Włochy
  if(prefix === "+39") {
    template = `Il vostro ordine sarà consegnato entro 30 minuti.`
  }
  // Holandia
  if(prefix === "+31") {
    template = `Je bestelling wordt binnen 30 minuten bezorgd.`
  }
  // Belgia
  if(prefix === "+32") {
    template = `Je bestelling wordt binnen 30 minuten bezorgd.`
  }
  // Austria
  if(prefix === "+43") {
    template = `Ihre Bestellung wird innerhalb von 30 Minuten zugestellt.`
  }

  return template
}

const notificationDayBeforeDelivery = (prefix, orderId, key, shortenId, code, isReturn) => {
  let template = ``
  
  if(isReturn)
  {
    // Polska
    if(prefix === "+48") {
      // template = `Twoje zamówienie jutro wyruszy z naszego magazynu. Potwierdź odbiór poprzez stronę: (https://sofart.me/${shortenId}). Kod odbioru zamówienia: ${code}.`
      template = `Twój zwrot zostanie odebrany we wskazanym terminie. Potwierdź odbiór poprzez stronę: (https://sofart.me/${shortenId}). Jeżeli nie potwierdzisz, zamówienie zostanie odebrane w ciągu kolejnych 14 dni. Kod odbioru zamówienia: ${code}.`
    }
    // Niemcy
    if(prefix === "+49") {
      // template = `Ihre Bestellung wird morgen unser Lager verlassen. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}). Code für die Abholung der Bestellung: ${code}.`
      template = `Ihre Rücksendung wird zu dem angegebenen Datum abgeholt. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}). Wenn Sie den Erhalt nicht bestätigen, wird Ihre Bestellung innerhalb der nächsten 14 Tage abgeholt. Code für die Abholung der Bestellung: ${code}`
    }
    // Francja
    if(prefix === "+33") {
      // template = `Votre commande quittera notre entrepôt demain. Confirmez la réception via le site web: (https://e-meubles.com/${shortenId}). Code d'enlèvement de la commande :${code}.`
      template = `Votre retour sera collecté à la date indiquée. Confirmez la réception via le site web : (https://e-meubles.com/${shortenId}). Si vous ne confirmez pas, votre commande sera enlevée dans les 14 jours suivants. Code d'enlèvement de la commande : ${code}`
    }
    // Luksemburg
    if(prefix === "+352") {
      // template = `Ihre Bestellung wird morgen unser Lager verlassen. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}). Code für die Abholung der Bestellung: ${code}.`
      template = `Ihre Rücksendung wird zu dem angegebenen Datum abgeholt. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}). Wenn Sie den Erhalt nicht bestätigen, wird Ihre Bestellung innerhalb der nächsten 14 Tage abgeholt. Code für die Abholung der Bestellung: ${code}`
    }
    // Włochy
    if(prefix === "+39") {
      // template = `Il vostro ordine lascerà il nostro magazzino domani. Confermare la ricezione tramite il sito web: (https://mbmoebel.com/${shortenId}). Codice di ritiro dell'ordine: ${code}.`
      template = `Il vostro reso sarà ritirato alla data indicata. Confermare la ricezione tramite il sito web: (https://mbmoebel.com/${shortenId}). In caso di mancata conferma, l'ordine verrà ritirato entro i 14 giorni successivi. Codice di ritiro dell'ordine: ${code}`
    }
    // Holandia
    if(prefix === "+31") {
      // template = `Je bestelling verlaat morgen ons magazijn. Bevestig de ontvangst via de website: (https://inspiremefurnitures.com/${shortenId}). Bestelcode afhalen: ${code}.`
      template = `Je retourzending wordt op de aangegeven datum opgehaald. Bevestig de ontvangst via de website: (https://inspiremefurnitures.com/${shortenId}). Als je niet bevestigt, wordt je bestelling binnen de volgende 14 dagen afgehaald. Verzamelcode bestelling: ${code}`
    }
    // Belgia
    if(prefix === "+32") {
      // template = `Je bestelde meubelstuk verlaat morgen ons magazijn. Bevestig de ontvangst via de website: (https://inspiremefurnitures.com/${shortenId}). Als je niet bevestigt, wordt je bestelling binnen de komende 14 dagen geleverd. Verzamelcode bestelling: ${code}.`
      template = `Je retourzending wordt op de aangegeven datum opgehaald. Bevestig de ontvangst via de website: (https://inspiremefurnitures.com/${shortenId}). Als je niet bevestigt, wordt je bestelling binnen de volgende 14 dagen afgehaald. Verzamelcode bestelling: ${code}`
    }
    // Austria
    if(prefix === "+43") {
      // template = `Ihre Bestellung wird morgen unser Lager verlassen. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}). Code für die Abholung der Bestellung: ${code}.`
      template = `Ihre Rücksendung wird zu dem angegebenen Datum abgeholt. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}). Wenn Sie den Erhalt nicht bestätigen, wird Ihre Bestellung innerhalb der nächsten 14 Tage abgeholt. Code für die Abholung der Bestellung: ${code}`
    }
  }
  else
  {
    // Polska
    if(prefix === "+48") {
      // template = `Twoje zamówienie jutro wyruszy z naszego magazynu. Potwierdź odbiór poprzez stronę: (https://sofart.me/${shortenId}). Kod odbioru zamówienia: ${code}.`
      // template = `Twój zamówiony mebel wyjedzie jutro z naszego magazynu. Potwierdź odbiór poprzez stronę: (https://sofart.me/${shortenId}). Jeżeli nie potwierdzisz, zamówienie zostanie dostarczone w ciągu kolejnych 14 dni. Kod odbioru zamówienia: ${code}.`
      template = `Twoja paczka została wysłana! Aby kurier mógł bez problemu ją dostarczyć, prosimy o potwierdzenie odbioru pod tym linkiem: (https://sofart.me/${shortenId}). Kod odbioru zamówienia: ${code}. Dziękujemy za zakupy i zaufanie!`
    }
    // Niemcy
    if(prefix === "+49") {
      // template = `Ihre Bestellung wird morgen unser Lager verlassen. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}). Code für die Abholung der Bestellung: ${code}.`
      // template = `Ihr bestelltes Möbelstück wird morgen unser Lager verlassen. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}. Wenn Sie nicht bestätigen, wird Ihre Bestellung innerhalb der nächsten 14 Tage geliefert. Abholcode bestellen: ${code}.`
      template = `Ihr Paket wurde versendet! Damit der Kurier es problemlos zustellen kann, bitten wir Sie, den Empfang unter diesem Link zu bestätigen: (https://moeblo.net/${shortenId}). Code für die Abholung der Bestellung: ${code}. Vielen Dank für Ihren Einkauf und Ihr Vertrauen!`
    }
    // Francja
    if(prefix === "+33") {
      // template = `Votre commande quittera notre entrepôt demain. Confirmez la réception via le site web: (https://e-meubles.com/${shortenId}). Code d'enlèvement de la commande :${code}.`
      // template = `Le meuble commandé quittera notre entrepôt demain. Confirmez la réception via le site web : (https://e-meubles.com/${shortenId}). Si vous ne confirmez pas, votre commande sera livrée dans les 14 jours suivants. Code d'encaissement de la commande : ${code}.`
      template = `Votre colis a été expédié ! Afin que le coursier puisse le livrer sans problème, nous vous invitons à confirmer la réception via ce lien : (https://e-meubles.com/${shortenId}). Code d'enlèvement de la commande : ${code}. Merci pour votre achat et votre confiance !`
    }
    // Luksemburg
    if(prefix === "+352") {
      // template = `Ihre Bestellung wird morgen unser Lager verlassen. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}). Code für die Abholung der Bestellung: ${code}.`
      // template = `Ihr bestelltes Möbelstück wird morgen unser Lager verlassen. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}. Wenn Sie nicht bestätigen, wird Ihre Bestellung innerhalb der nächsten 14 Tage geliefert. Abholcode bestellen: ${code}.`
      template = `Ihr Paket wurde versendet! Damit der Kurier es problemlos zustellen kann, bitten wir Sie, den Empfang unter diesem Link zu bestätigen: (https://moeblo.net/${shortenId}). Code für die Abholung der Bestellung: ${code}. Vielen Dank für Ihren Einkauf und Ihr Vertrauen!`
    }
    // Włochy
    if(prefix === "+39") {
      // template = `Il vostro ordine lascerà il nostro magazzino domani. Confermare la ricezione tramite il sito web: (https://mbmoebel.com/${shortenId}). Codice di ritiro dell'ordine: ${code}.`
      // template = `Il mobile ordinato lascerà il nostro magazzino domani. Confermate la ricezione tramite il sito web: (https://mbmoebel.com/${shortenId}). In caso di mancata conferma, l'ordine verrà consegnato entro i prossimi 14 giorni. Codice di ritiro dell'ordine: ${code}.`
      template = `Il tuo pacco è stato spedito! Affinché il corriere possa consegnarlo senza problemi, ti invitiamo a confermare la ricezione tramite questo link: (https://mbmoebel.com/${shortenId}). Codice di ritiro dell'ordine: ${code}. Grazie per il tuo acquisto e la tua fiducia!`
    }
    // Holandia
    if(prefix === "+31") {
      // template = `Je bestelling verlaat morgen ons magazijn. Bevestig de ontvangst via de website: (https://inspiremefurnitures.com/${shortenId}). Bestelcode afhalen: ${code}.`
      // template = `Je bestelde meubelstuk verlaat morgen ons magazijn. Bevestig de ontvangst via de website: (https://inspiremefurnitures.com/${shortenId}). Als je niet bevestigt, wordt je bestelling binnen de komende 14 dagen geleverd. Verzamelcode bestelling: ${code}.`
      template = `Je pakket is verzonden! Om ervoor te zorgen dat de koerier het zonder problemen kan bezorgen, vragen we je om de ontvangst via deze link te bevestigen: (https://inspiremefurnitures.com/${shortenId}). Verzamelcode bestelling: ${code}. Bedankt voor je aankoop en vertrouwen!`
    }
    // Belgia
    if(prefix === "+32") {
      // template = `Je bestelde meubelstuk verlaat morgen ons magazijn. Bevestig de ontvangst via de website: (https://inspiremefurnitures.com/${shortenId}). Als je niet bevestigt, wordt je bestelling binnen de komende 14 dagen geleverd. Verzamelcode bestelling: ${code}.`
      template = `Je pakket is verzonden! Om ervoor te zorgen dat de koerier het zonder problemen kan bezorgen, vragen we je om de ontvangst via deze link te bevestigen: (https://inspiremefurnitures.com/${shortenId}). Verzamelcode bestelling: ${code}. Bedankt voor je aankoop en vertrouwen!`
    }
    // Austria
    if(prefix === "+43") {
      // template = `Ihre Bestellung wird morgen unser Lager verlassen. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}). Code für die Abholung der Bestellung: ${code}.`
      // template = `Ihr bestelltes Möbelstück wird morgen unser Lager verlassen. Bestätigen Sie den Empfang über die Website: (https://moeblo.net/${shortenId}. Wenn Sie nicht bestätigen, wird Ihre Bestellung innerhalb der nächsten 14 Tage geliefert. Abholcode bestellen: ${code}.`
      template = `Ihr Paket wurde versendet! Damit der Kurier es problemlos zustellen kann, bitten wir Sie, den Empfang unter diesem Link zu bestätigen: (https://moeblo.net/${shortenId}). Code für die Abholung der Bestellung: ${code}. Vielen Dank für Ihren Einkauf und Ihr Vertrauen!`
    }
    
  }

  return template
}

const changedDeliveryTimeTemplate = (prefix, time) => {
  let template = ``

  // Polska
  if(prefix === "+48") {
    template = `Zmiana godziny dostawy. Nowa godzina: ${time}. Przepraszamy.`
  }
  // Niemcy
  if(prefix === "+49") {
    template = `Änderung der Lieferfrist. Neue ungefähre Zeit: ${time}. Entschuldigung.`
  }
  // Francja
  if(prefix === "+33") {
    template = `Modification du délai de livraison. Nouveau délai approximatif : ${time}. Désolé.`
  }
  // Luksemburg
  if(prefix === "+352") {
    template = `Änderung der Lieferfrist. Neue ungefähre Zeit: ${time}. Entschuldigung.`
  }
  // Włochy
  if(prefix === "+39") {
    template = `Modifica dell'orario di consegna. Nuovo orario approssimativo: ${time}. Spiacente.`
  }
  // Holandia
  if(prefix === "+31") {
    template = `Wijziging van levertijd. Nieuwe geschatte tijd: ${time}. Sorry.`
  }
  // Belgia
  if(prefix === "+32") {
    template = `Wijziging van levertijd. Nieuwe geschatte tijd: ${time}. Sorry.`
  }
  // Austria
  if(prefix === "+43") {
    template = `Änderung der Lieferfrist. Neue ungefähre Zeit: ${time}. Entschuldigung.`
  }

  return template
}


module.exports = function(data) { 
  let template = ``

  if(data.messageType === 'halfHour') {
    template = halfHourTemplates(data.prefix)
  }

  if(data.messageType === 'changeDeliveryTime') {
    template = changedDeliveryTimeTemplate(data.prefix, data.time)
  }

  if(data.messageType === 'notificationDayBeforeDelivery') {
    template = notificationDayBeforeDelivery(data.prefix, data.orderId, data.key, data.shortenId, data.code, data.return)
  }

  return template
}

